import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { Icon } from '@iconify/react';
import { isSolutionEntity } from '@ipen-portal/ipen-entity-model';
import {
  EnhancedNavItemBlueprint,
  EntityToolbarElementBlueprint,
} from '@ipen-portal/plugin-common-react';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { orderRouteRef, ordersRouteRef } from './routes';
import { solutionContractingApiRef } from './utils/trpc';

export const solutionContractingPlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'solution-contracting-api',
      params: defineParams =>
        defineParams({
          apiRef: solutionContractingApiRef,
          path: 'solution-contracting',
        }),
    }),
    EnhancedNavItemBlueprint.make({
      attachTo: { id: 'app/nav', input: 'items' },
      params: {
        icon: <Icon fontSize={32} icon="mdi:contract" />,
        target: '/solution-contracting/orders',
        title: 'Solution Contracting',
      },
    }),
    PageBlueprint.make({
      name: 'SolutionContractingOrders',
      params: {
        loader: async () =>
          import('./components/OrdersPage/OrdersPage').then(m => (
            <m.OrdersPage />
          )),
        noHeader: true,
        path: '/solution-contracting/orders',
        routeRef: ordersRouteRef,
      },
    }),
    PageBlueprint.make({
      name: 'SolutionContractingOrder',
      params: {
        loader: async () =>
          import('./components/OrderPage/OrderPage').then(m => <m.OrderPage />),
        noHeader: true,
        path: '/solution-contracting/orders/:id',
        routeRef: orderRouteRef,
      },
    }),
    EntityToolbarElementBlueprint.make({
      name: 'SolutionContractingToolbarElement',
      params: {
        component: async () =>
          import('./components/OrderSolutionButton').then(m => () => (
            <m.OrderSolutionButton />
          )),
        filter: isSolutionEntity,
        path: '/',
      },
    }),
  ],
  featureFlags: [
    {
      name: 'solution-contracting',
    },
  ],
  pluginId: 'solution-contracting',
});
